const CircleLoader = ({...rest}) => (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="50" cy="50" fill="none" strokeWidth="8" r="40" className="stroke-current bg-transparent" strokeDasharray="188.49555921538757 64.83185307179586">
            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"/>
        </circle>
    </svg>
)

export default CircleLoader